<template>
  <v-sheet :class="['duration-item', classes]">
    <v-list class="duration-item__list">
      <v-list-item-group
        :value="lazyValue"
        :color="color"
        mandatory
        @change="change"
      >
        <v-list-item
          v-for="{ index, value, disabled } in computedOptions"
          :key="index"
          :value="value"
          :disabled="disabled"
        >
          <v-list-item-content>
            <v-list-item-title v-text="value" />
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-sheet>
</template>

<script>
import themeable from 'vuetify/lib/mixins/themeable';

export default {
  name: 'DurationItem',

  inject: ['register', 'unregister'],

  mixins: [themeable],

  props: {
    value: {
      type: Number,
      required: true
    },
    multiplier: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    allowedValues: {
      type: Function,
      default: () => true
    },
    color: {
      type: String,
      default: 'primary'
    },
    hideNotAllowedOptions: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      lazyValue: this.value
    };
  },

  computed: {
    classes() {
      return {
        ...this.themeClasses
      };
    },
    internalValue: {
      get() {
        return this.lazyValue;
      },

      set(val) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },
    computedOptions() {
      const options = this.options.map((value, index) => {
        return {
          index,
          value,
          disabled: !this.allowedValues(value)
        };
      });

      if (this.hideNotAllowedOptions) {
        return options.filter(({ disabled }) => !disabled);
      }

      return options;
    }
  },

  watch: {
    value(val) {
      this.lazyValue = val;
    },
    lazyValue: 'scroll'
  },

  mounted() {
    this.register(this);
    setTimeout(this.scroll, 100);
  },

  beforeDestroy() {
    this.unregister(this);
  },

  methods: {
    change(value) {
      this.internalValue = value;
    },

    scroll() {
      requestAnimationFrame(() => {
        const list = this.$el;
        const active = list.querySelector('.v-list-item--active');

        list.scrollTop = active
          ? Math.max(0, active.offsetTop + active.offsetHeight / 2)
          : list.scrollTop;
      });
    },

    getSeconds() {
      return this.lazyValue * this.multiplier;
    },

    getText() {
      return `${this.lazyValue}${this.type}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.duration-item {
  flex: 1;
  text-align: center;
  overflow-x: hidden;

  &:before,
  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 50%;
  }
}
</style>
